import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { InputError, InputWrapper, SelectExtended, TextInputExtended } from 'src/components';
import { store } from 'src/feature-app';
import { useOneFormContext } from 'src/feature-app/OneForm';
import { OneFormState } from 'src/types';
import styled from 'styled-components';

const FlexWrapper = styled.div`
	display: flex;
	& > div {
		margin-right: 20px;
		width: 120px;
	}
	& > label {
		flex: 1;
	}
`;

interface dniNifProps {
	name?: string;
	label?: string;
	required?: boolean;
	disabled?: boolean;
	paddingTop?: string;
	paddingBottom?: string;
	selectType?: boolean;
}

export function DniNif(props: dniNifProps) {
	const { name, label, required, disabled, selectType } = props;

	const { register } = useFormContext();
	const dispatch = useDispatch();
	const { formInfo }: OneFormState = store.getState();
	const [inputValue, setInputValue] = useState('');
	const [type, setType] = useState('DNI');
	const [selectedTypeLabel, setselectedTypeLabel] = useState(type);
	const [dniNifError, setDniNifError] = useState(false);
	const [maxLenght, setMaxLenght] = useState(9);
	const { error, setError } = useOneFormContext();
	const regExpDNI = /^[0-9]{8}[A-z]$/;
	const regExpNIE = /^[XYZxyz][0-9]{7}[A-Za-z]$/;
	const lengthOtro = 20;
	const letras = 'TRWAGMYFPDXBNJZSQVHLCKE';

	const { nifType } = useSelector((state: OneFormState) => state.formData.fields);

	const checkValidDNIRegex = (dni: string) => regExpDNI.test(dni);
	const checkValidDNILetter = (dni: string) => {
		const regex = /^(\d{8})([A-Z])$/i;
		const match = dni.match(regex);
		if (!match) return false;
		const numero = parseInt(match[1], 10);
		const letraCalculada = letras[numero % 23];
		const letraIngresada = match[2].toUpperCase();
		return letraCalculada === letraIngresada;
	};

	const checkValidNIERegex = (nie: string) => regExpNIE.test(nie);
	const checkValidNIELetter = (nie) => {
		// Reemplazar la primera letra por su número correspondiente
		const mapa = { X: '0', Y: '1', Z: '2' };
		const numero = mapa[nie[0]] + nie.slice(1, 8);
		const letraCalculada = letras[numero % 23];
		const letraIngresada = nie[8].toUpperCase();
		return letraCalculada == letraIngresada;
	};

	const validateValue = (value: string) => {
		if (type == 'DNI') {
			return value?.length == 9 && checkValidDNIRegex(value) && checkValidDNILetter(value);
		} else if (type == 'NIE') {
			return value?.length == 9 && checkValidNIERegex(value) && checkValidNIELetter(value);
		} else {
			return value?.length < lengthOtro + 1;
		}
	};

	const getUsedRegex = () => {
		if (type == 'DNI') {
			return regExpDNI;
		} else if (type == 'NIE') {
			return regExpNIE;
		} else {
			return new RegExp(`^.{1,${lengthOtro + 1}}$`);
		}
	};

	const getErrorLabel = () => {
		if (type == 'DNI') {
			return 'Ejemplo: 66666666Q';
		} else if (type == 'NIE') {
			return 'Ejemplo: X6666666Q';
		} else {
			return 'Error';
		}
	};

	const handleChange = (e: any) => {
		const value = e.target.value.toUpperCase();
		if (value?.length > 3) {
			setInputValue(value);
			if (validateValue(value)) {
				setDniNifError(false);
				//setError(false);
				dispatch({ type: 'UPDATE_FIELDS', payload: { [name ? name : 'dniNif']: value } });
			} else {
				setDniNifError(true);
				//setError(true);
			}
		} else {
			setDniNifError(false);
			//setError(false);
		}
	};

	const handleChangeType = (e: any) => {
		const type = e.currentTarget.value;
		setType(type);
		setselectedTypeLabel(type);
		if (type != 'DNI' && type != 'NIE') {
			setMaxLenght(lengthOtro);
		} else {
			setMaxLenght(9);
		}
		dispatch({ type: 'UPDATE_FIELDS', payload: { nifType: type } });
	};

	return (
		<InputWrapper className="dni-input-wrapper" notALayer={formInfo.notALayer} paddingTop={props.paddingTop} paddingBottom={props.paddingBottom}>
			<FlexWrapper>
				{selectType ? <SelectExtended name="nifType" label="Tipo" value={nifType ? nifType : 'DNI'} required options={['DNI', 'NIE', 'Otro']} handleChange={handleChangeType} onClick={() => {}} updateFields setOption={setType} isRequired={true} /> : null}

				<TextInputExtended
					name={name ? name : 'dniNif'}
					label={label ? label : selectedTypeLabel}
					value={inputValue ? inputValue : ''}
					isFloating
					innerRef={register({
						required: {
							value: required ? required : false,
							message: 'Requerido',
						},
						pattern: {
							value: getUsedRegex(),
							message: 'Error',
						},
					})}
					onChange={(e) => handleChange(e)}
					required={required ? required : false}
					disabled={disabled}
					maxLength={maxLenght}
				/>
			</FlexWrapper>
			{dniNifError && <InputError className="input-error">{getErrorLabel()}</InputError>}
		</InputWrapper>
	);
}
